import * as React from "react";
const SvgFiRrMarketplaceAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-marketplace-alt_svg__a)">
      <path
        fill="#062147"
        d="M16 11.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 16 11.5m3 0a1.5 1.5 0 1 0 3.001-.001A1.5 1.5 0 0 0 19 11.5M10 1a1 1 0 0 1 1-1h.316c1.292 0 2.414.816 2.83 2H22a1.98 1.98 0 0 1 1.612.816c.381.519.488 1.169.296 1.783l-.722 2.299A2.985 2.985 0 0 1 20.324 9h-4.429a2.99 2.99 0 0 1-2.956-2.49l-.637-3.681a1 1 0 0 0-.986-.83H11A1 1 0 0 1 10 1m4.534 3 .375 2.17c.083.481.497.83.985.83h4.429a.995.995 0 0 0 .954-.7l.722-2.3zM23 14a1 1 0 0 0-1 1c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h3a1 1 0 0 0 0-2H5C2.243 2 0 4.243 0 7v8c0 2.757 2.243 5 5 5h6v2H7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2h-4v-2h6c2.757 0 5-2.243 5-5a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-marketplace-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMarketplaceAlt;
